var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("" + (_vm.revert ? '-mx-6 sm:-mx-9' : 'px-6 sm:px-9'))},[(_vm.maxWidthClass)?_c('div',{class:("mx-auto " + _vm.maxWidthClass)},[_vm._t("default")],2):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }